import { GachaPrize } from "@/lib/models/gacha_prize";
import { light_offer_extended } from "@/lib/models/light_offer_extended";

/**
 * Transform gacha prize data to light_offer_extended format
 * This allows gacha prizes to be displayed alongside regular offers
 */
export function transformGachaPrizeToOffer(
  prize: GachaPrize,
): light_offer_extended {
  // Parse the date string to ISO format
  const parseAvailableDate = (dateStr: string): string => {
    try {
      // Format: "2026/02/16 18:57:00"
      const [datePart, timePart] = dateStr.split(" ");
      const [year, month, day] = datePart.split("/");
      return `${year}-${month}-${day}T${timePart}`;
    } catch {
      return new Date().toISOString();
    }
  };

  return {
    // Use negative IDs to avoid conflicts with regular offers
    id: prize.userPrizeId,
    ref: `GACHA-${prize.userPrizeId}`,
    title: prize.prizeName,
    subtitle: prize.description || "",
    discount_value: 0, // Gacha prizes don't have discount values
    picture_url: prize.prizeThumbnailUri,
    barcode: prize.barcode || "",
    user_quota: 1,
    best: false,
    is_new: prize.newflg === 1,
    points: prize.point || 0,
    is_holder_required: false,
    default_target: false,
    precedence: 0,
    ended_at: parseAvailableDate(prize.availableDateLimit),
    unavailable_clip_image_url: "",
    unavailable_clip_text: "",
    // Gacha API provides "usage" (how to use). We map it to the existing
    // offer overview_html so it can be rendered by OfferDetails.
    overview_html: prize.usage || prize.description || "",
    disclaimer_html: prize.terms,
    discount_type: 0,
    // Mark as gacha offer for special handling
    bl_message_ref: undefined,
    keep: prize.keep,
    used: prize.used,
  };
}
